import React from 'react';
import { withRouter } from "react-router-dom";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import {Input} from '../../components/Input.js'
import Page from '../../components/Page'
import { withStyles } from "@material-ui/core/styles";

import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import "./Login.css"
import { LoginForm,Userreviews } from './components';
import {
  Card,
  CardContent,
  CardMedia,
  Divider,
  Link,
  Avatar
} from '@material-ui/core';

const useStyles = theme => ({
  root: {
    //maxWidth: 345,
  },
});

export class Login extends React.Component {

   
  render() {

  return (
    <Page
    className='root'
      title="Login"
    >

      <div className='loginbg'>

      </div>
      <LoginForm />
      {/* <Userreviews /> */}

        </Page>
         
  );
}
}


  
  export default (withRouter(Login));